/* ENEA glass zoom cursor (2026-07-02)
 * Replaces the static magnifier cursor on PDP gallery images with a
 * Polene-style follower: a liquid-glass circle with two corner brackets
 * that tracks the mouse. Desktop (fine pointer) only; the native cursor
 * is hidden over the gallery. The old magnifier CSS in theme.liquid is
 * overridden by the cursor:none rule injected here (same selectors,
 * injected later in the document, so it wins at equal specificity).
 * To revert: delete this file + its <script> tag in snippets/loading.liquid.
 */
(function () {
  if (window.__eneaGlassCursor) return; window.__eneaGlassCursor = true;
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SEL = '.product-gallery a.product-gallery__media-link, .product-gallery .product-gallery__media-link, .product-gallery a';

  var CSS = '.product-gallery a.product-gallery__media-link, .product-gallery .product-gallery__media-link, .product-gallery a { cursor: none !important; }' +
    '.enea-glass-cursor{position:fixed;top:0;left:0;pointer-events:none;z-index:2147483000;will-change:transform}' +
    '.enea-glass-cursor__in{display:flex;align-items:center;justify-content:center;width:56px;height:56px;margin:-28px 0 0 -28px;border-radius:50%;' +
    'background-color:rgba(255,255,255,0.16);background-image:linear-gradient(180deg,rgba(255,255,255,0.24),rgba(255,255,255,0.10));' +
    '-webkit-backdrop-filter:blur(10px) saturate(185%) brightness(1.05);backdrop-filter:blur(10px) saturate(185%) brightness(1.05);' +
    'box-shadow:inset 0 1px 0 rgba(255,255,255,0.35),0 2px 12px rgba(0,0,0,0.10);' +
    'opacity:0;transform:scale(0.4);transition:opacity .18s ease,transform .18s ease}' +
    '.enea-glass-cursor.is-active .enea-glass-cursor__in{opacity:1;transform:scale(1)}' +
    '.enea-glass-cursor svg{width:20px;height:20px;display:block}';

  /* Polene-style glyph: two thin corner brackets, top-left + bottom-right (2026-07-02) */
  var ARROWS = '<svg viewBox="0 0 24 24" fill="none" stroke="#171412" stroke-width="1.2" stroke-linejoin="miter" aria-hidden="true"><path d="M6 11V6h5"/><path d="M18 13v5h-5"/></svg>';

  function init() {
    if (document.querySelector('.enea-glass-cursor')) return;
    try { var st = document.createElement('style'); st.setAttribute('data-enea-glass-cursor', ''); st.textContent = CSS; document.head.appendChild(st); } catch (e) {}
    var el = document.createElement('div');
    el.className = 'enea-glass-cursor'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="enea-glass-cursor__in">' + ARROWS + '</span>';
    document.body.appendChild(el);
    var active = false;
    document.addEventListener('mousemove', function (e) {
      el.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
      var over = e.target && e.target.closest && e.target.closest(SEL);
      /* never show while the photoswipe zoom overlay is open */
      if (over && document.querySelector('.pswp--open')) over = null;
      if (!!over !== active) { active = !!over; el.classList.toggle('is-active', active); }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { if (active) { active = false; el.classList.remove('is-active'); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
